import { render } from "./main-logo.vue?vue&type=template&id=1ce52246&ts=true"
import script from "./main-logo.vue?vue&type=script&lang=ts"
export * from "./main-logo.vue?vue&type=script&lang=ts"

import "./main-logo.vue?vue&type=style&index=0&id=1ce52246&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__